/** Dispatched when AI Insights chat opens so routes can dismiss overlapping drawers/modals. */
declare global {
  interface WindowEventMap {
    'zoomlogi-close-ui-overlays': CustomEvent;
  }
}

export const ZOOMLOGI_CLOSE_UI_OVERLAYS_EVENT =
  'zoomlogi-close-ui-overlays' as const;

export function dispatchZoomlogiCloseUiOverlays(): void {
  window.dispatchEvent(new CustomEvent(ZOOMLOGI_CLOSE_UI_OVERLAYS_EVENT));
}

/** Dispatched after a FedEx pickup is scheduled/cancelled so the open detail drawer refetches. */
export const FEDEX_PICKUP_CHANGED_EVENT =
  'zoomlogi-fedex-pickup-changed' as const;

export function dispatchFedExPickupChanged(shipmentId: string): void {
  window.dispatchEvent(
    new CustomEvent(FEDEX_PICKUP_CHANGED_EVENT, { detail: { shipmentId } })
  );
}
